import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalFooter, ModalHeader, ModalContent, RegularButton } from 'fronton-react';
import { displayTooltipModalContent } from './styles';

export type DisplayTooltipModalProps = {
  modalVisibility: boolean;
  setModalVisibility: (visible: boolean) => void;
};

export const DisplayTooltipModal: React.FC<DisplayTooltipModalProps> = ({
  modalVisibility,
  setModalVisibility,
}) => {
  const { t } = useTranslation();
  const onClose = useCallback(() => {
    setModalVisibility(false);
  }, [setModalVisibility]);
  return (
    <Modal size="s" variant="curtain" show={modalVisibility} onClose={onClose}>
      <ModalHeader title={t('product-info.stocks.in-stores.has-sample-modal')} />
      <ModalContent className={displayTooltipModalContent}>
        {t('product-info.stocks.in-stores.tooltip-content')}
      </ModalContent>
      <ModalFooter>
        <RegularButton onClick={onClose} size="l" variant="secondary">
          {t('product-info.online-order-only.got-it')}
        </RegularButton>
      </ModalFooter>
    </Modal>
  );
};
